import { ClarificationDocument } from "./clarification-request.types";
import { PpmOpinion } from "./ppm.types";
import { JointDoc } from "./process-common";

export interface DemandeReportItem {
  id: number;
  joursDemandes: number;
  motifDemande: string;
  createdAt: string;
  statut: string;
  dacId: number;
  societeNom?: string;
  societeNif?: string;
  societePays?: string;
}

export interface DacDemandeGroup {
  dacReference: string;
  realisationEnvisagees?: string;
  dateLimiteSoumission?: string;
  demandes: DemandeReportItem[];
}

export interface DemandeReportsResponse {
  demandes: DacDemandeGroup[];
  total: number;
}

// Flattened type for display in table
export interface FlattenedDemandeReport extends DemandeReportItem {
  dacReference: string;
}

export interface DemandeReportRequest {
  joursDemandes: number;
  motifDemande: string;
  dacId: number;
  originalAdditifId: number;
}

export interface ReportAdditif {
  id: number;
  joursDemandes: number;
  motifDemande: string;
  idAdditif: number;
  originalAdditifId: number;
  dacId: number;
  dacVer: number;
  demandePar: string;
  dateDemande: string;
  statut: string;
  joursAccordes: number;
  commentaireDecision: string;
  decidePar: string;
  dateDecision: string;
  processInstanceId: string;
  sourceReport: string;
  dacReference?: string;
}

export enum SourceDemande {
  DEMANDE_AC = 'DEMANDE_AC',
  DEMANDE_CANDIDATS = 'DEMANDE_CANDIDATS',
}

export interface CreateReportAdditifRequest {
  dacId: number | null;
  dateReport: Date | string | null;
  motifReport: string | null;
  sourceDemande: SourceDemande | null;
}

export interface ReportAdditifRequest {
  dacId: number;
  dateReport: Date | string;
  motifReport: string;
  sourceDemande: SourceDemande;
}

export interface ReportAdditifResponseDto {
  id: number;
  reference: string;
  version: number;
  dacId: number;
  dacVer: number;
  dacReference: string;
  validationStatus: string;
  description: string;
  dateReport: string;
  motifReport: string;
  status: string;
  sourceDemande: SourceDemande;
  processInstanceId: string;
  etapeProcess: string;
  docId: number;
  docName: string;
  publishedAt: string;
  comIds: number[];
  demandeReportsCount: number;
  modelDoc: ClarificationDocument;
}

export interface ReportDacDetails {
  dacId: number;
  referenceDac: string;
  aoReference: string;
  ppmNom: string;
  realisationEnvisagees: string;
  typeMarche: string;
  modePassationLibelle: string;
  dateLimiteSoumission: string | Date | null;
  dateLimiteReception: string | Date | null;
  dateOuverture: string | Date | null;
}

export interface ReportResponseDTO {
  id: number;
  reference: string;
  datereport: string;
  motifreport: string;
  dacReference: string;
  status: string;
  sourceDemande?: SourceDemande;
  modelDoc?: ClarificationDocument | null;
  dac?: ReportDacDetails;
}

export interface ReportTaskDetailsDTO {
  taskId: string;
  taskName: string;
  taskDefinitionKey: string;
  assignee: string;
  processInstanceId: string;
  candidateGroup: string;
  comId: number;
  report: ReportResponseDTO;
  status: string;
  traceability: any;
  isUpdatable: boolean;
  isPublishable: boolean;
  commissionRequired: boolean;
  meetingRequired: boolean;
  assignRapporteur: boolean;
  hasTask: boolean;
  nextSteps: any[];
  avis: PpmOpinion[];
  pvCpmp: JointDoc[];
  pvCncmpPermanente: JointDoc[];
  pvCncmpSpecialisee: JointDoc[];
  extraitCncmpPermanente: JointDoc[];
  extraitCpmp: JointDoc[];
  documentCNCMPSpecialisee: JointDoc[];
  documentCNCMPPermanente: JointDoc[];
  documentCPMP: JointDoc[];
}

export enum CncmpDecision {
  FAVORABLE = 'FAVORABLE',
  DEFAVORABLE = 'DEFAVORABLE',
  FAVORABLE_SOUS_RESERVE = 'FAVORABLE_SOUS_RESERVE',
}

export interface ReportValidationRequest {
  taskId?: string;
  validate?: boolean;
  comment?: string;
  avis?: string;
  assigneeUserId?: string;
  comId?: number;
  cncmpDecision?: CncmpDecision;
  docIdNote?: number;
  dateReport?: Date | string;
  dateOuverture?: Date | string;
  motifReport?: string;
  fromMeeting?: boolean;
}

